"use strict";

import React from 'react';
import OFS_I18N from 'ofs/i18n'

var gettext = OFS_I18N.gettext;
var interpolate = OFS_I18N.interpolate;

var messages = {
  HAS_MIN_NO_MAX: gettext('This home has a minimum stay of %(minimum_stay)s nights.'),
  HAS_MIN_AND_MAX: gettext('This home has a minimum stay of %(minimum_stay)s nights and a maximum of %(maximum_stay)s nights.'),
  HAS_MAX_NO_MIN: gettext('This home has a maximum stay of %(maximum_stay)s nights.')
};

export function generateMinMaxMessage(min, max) {
  if (min > 1 && !max) {
    return interpolate(messages.HAS_MIN_NO_MAX, {'minimum_stay': min}, true);
  } else if (min > 1 && max > 1) {
    return interpolate(messages.HAS_MIN_AND_MAX, {'minimum_stay': min, 'maximum_stay': max}, true);
  } else if (!min && max > 1) {
    return interpolate(messages.HAS_MAX_NO_MIN, {'maximum_stay': max}, true);
  }
};

var MinMaxMessage = React.createClass({
  render() {
    var message = generateMinMaxMessage(this.props.min, this.props.max);

    if (message) {
      return (
        <div className="min-max-message">
          {message}
        </div>
      );
    } else {
      return null;
    }
  }
});

export default MinMaxMessage;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/MinMaxMessage.jsx
 **/